module.exports = __webpack_public_path__ + "static/media/settings_room_device_mic.4352ecfb.svg";